import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { getStoredAuth } from "../helpers/auth_storage";
import { getIdentitySession } from "../helpers/identity_storage";
import { setAuthorization } from "../helpers/api_helper";
import {
  decodeJwtExpSeconds,
  startTokenSessionKeeper,
} from "../helpers/token_session";

const isSessionValid = (): boolean => {
  const auth = getStoredAuth();

  if (!auth?.token) {
    return false;
  }

  const exp = decodeJwtExpSeconds(auth.token);

  if (exp === null) {
    return Boolean(auth.refreshToken);
  }

  const isExpired = Date.now() >= exp * 1000;

  if (isExpired) {
    return Boolean(auth.refreshToken);
  }

  return true;
};

interface AuthProtectedProps {
  children: React.ReactNode;
}

const AuthProtected = ({ children }: AuthProtectedProps) => {
  const location = useLocation();

  useEffect(() => {
    const auth = getStoredAuth();

    if (auth?.token) {
      setAuthorization(auth.token);
    }

    return startTokenSessionKeeper();
  }, []);

  if (!isSessionValid()) {
    if (getIdentitySession()) {
      return <Navigate to="/select-studio" state={{ from: location }} replace />;
    }

    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default AuthProtected;
